import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ListRendererWidgetBase } from '@capturum/builders/list-renderer';

@Component({
  selector: 'app-time-difference-widget',
  templateUrl: './time-difference-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeDifferenceWidgetComponent extends ListRendererWidgetBase {}
